import { GridGetRowsResponse } from '@mui/x-data-grid-pro';
import type { GridRowModel } from '@mui/x-data-grid/models';

export const makeGridGetRowsResponse = <R extends GridRowModel>(rows: R[], rowCount: number): GridGetRowsResponse => {
  return { rows, rowCount };
};
